import React from 'react'
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material'
import './style.css'

const CustomSelect = (props) => {
  const {
    id = 'mui-select',
    size = 'small',
    required = false,
    fullWidth,
    label,
    itemList,
    error = false,
    helperText = '',
    width = 120,
    ...rest
  } = props
  return (
    <div className={`custom-select ${size} ${required ? 'required' : 'unrequired'}`}>
      <FormControl error={error} fullWidth sx={{ m: 1, minWidth: width }} size={size} required={required}>
        <InputLabel>{label || ''}</InputLabel>
          <Select label={label || ''} {...rest}>
            {
              itemList && itemList.length ? itemList.map((e, i) => (
                <MenuItem key={`${id}-${i}`} value={e.value}>{e.name}</MenuItem>
              )) : null
            }
          </Select>
        <FormHelperText>{helperText}</FormHelperText>
      </FormControl>
    </div>
  )
}

export default CustomSelect
